import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 自定义基础样式库
import './styles/index.css'

// 引入vantUI
import vant from 'vant';
import 'vant/lib/index.css';

Vue.use(vant);

// 移动端适配
import 'amfe-flexible';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
